/**
 * main collection: https://www.svgrepo.com/collection/bootstrap-ui-icons/
 * specific icon: https://www.svgrepo.com/svg/344644/chevron-down
 */

type Props = {
  size?: number | string;
  color?: string;            // leave undefined to inherit
  className?: string;
  style?: React.CSSProperties;
  title?: string;
};

const ChevronDown = ({
  size = 16,
  color = 'currentColor',    // inherit from parent by default
  className,
  style,
  title
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 16 16'
    fill={color}       // key: follow parent text color
    aria-hidden={title ? undefined : true}
    role={title ? 'img' : 'presentation'}
    className={className}
    style={style}
  >
    {title ? <title>{title}</title> : null}
    <path
      fillRule='evenodd'
      d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'
    />
  </svg>
);

export default ChevronDown;
